// extracted by mini-css-extract-plugin
export default {"textarea":"TextareaField_textarea__2TSb6","group":"TextareaField_group__oGgnj","group_full":"TextareaField_group_full__CiLkB"};